import { useLocalSearchParams, useRouter } from 'expo-router'
import { useEffect } from 'react'
import { View } from 'react-native'

import Snackbar from '@/components/snackbar/Snackbar'
import UniActivityIndicator from '@/components/unistyles/UniActivityIndicator'
import UniText from '@/components/unistyles/UniText'
import { verifyEmail } from '@/utils/auth/auth'

const Verify = () => {
  const router = useRouter()

  // This doesn't work on web because the hash is not included in the URL
  const routeParams = useLocalSearchParams<{
    rid: string
    token: string
    tenantId: string
    '#': string
  }>()

  useEffect(() => {
    async function verify() {
      const response = await verifyEmail(routeParams.token)

      if (response.status === 'OK') {
        router.navigate('/')
      } else {
        Snackbar.error('There was a problem verifying your email')
      }
    }

    verify()
  }, [routeParams.token, router])

  return (
    <View
      style={{
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <UniActivityIndicator animating={true} size="large" />
      <UniText style={{ marginTop: 10 }}>
        Validating your login credentials...
      </UniText>
    </View>
  )
}

export default Verify
